"use client";

import { Form, Input, Button, Typography, message } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import service from "../api/FetchInterceptor";

const { Title, Paragraph } = Typography;

const ForgotPassword = () => {
    const [form] = Form.useForm();
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onSubmit = async (values) => {
        setLoading(true);
        try {
            const response = await service({
                method: "POST",
                url: "forgot-password",
                data: values,
            });

            message.success(response.message || "Email envoyé.");
            setSent(true);
        } catch (error) {
            message.error(
                error.response?.data?.message || "Une erreur est survenue."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col min-h-screen items-center justify-center md:bg-blue-50">
            <img src="/logo_black.png" alt="PSIE" className="w-50 -mt-32" />

            <div className="w-full max-w-xl mx-4 p-6 rounded-lg bg-white mt-8 shadow">
                <Title level={3}>Mot de passe oublié</Title>

                {sent ? (
                    <Paragraph>
                        Si un compte existe avec cette adresse, un email
                        contenant les instructions de réinitialisation vient
                        de lui être envoyé.
                    </Paragraph>
                ) : (
                    <>
                        <Paragraph>
                            Saisissez votre adresse email, nous vous enverrons
                            un lien pour réinitialiser votre mot de passe.
                        </Paragraph>

                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onSubmit}
                            className="mt-4"
                        >
                            <Form.Item
                                label="Adresse e-mail"
                                name="email"
                                rules={[
                                    { required: true, message: "L'adresse email est requise" },
                                    { type: "email", message: "L'adresse email n'est pas valide" },
                                ]}
                            >
                                <Input placeholder="Entrez votre email" size="large" />
                            </Form.Item>

                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                block
                                loading={loading}
                            >
                                Envoyer le lien de réinitialisation
                            </Button>
                        </Form>
                    </>
                )}

                <Button
                    type="link"
                    className="mt-2 px-0"
                    onClick={() => navigate("/login")}
                >
                    Retour à la connexion
                </Button>
            </div>
        </div>
    );
};

export default ForgotPassword;
